import { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';

import { TextField } from 'basic-components';
import { CommonService } from 'dashboard-services/services';

import { FormulaUtils } from 'utils';

const LimitContracts = ({ onChange, value = undefined, symbolSizeOverridden = false }) => {
  const onChangeLocal = useCallback((val, { name }) => {
          if(val === "") {
            onChange(undefined, { name })
            return;
          }
          if(!CommonService.isNumber(val)) {
            return;
          }
          const valFor = Number(val) < 0 ? Number(val) * -1 : val
          onChange(valFor, { name })
        }, [onChange])
  return (
    <Fragment>
      <div
          className="ng-office-app__authed__content__body__item__expanded-settings__bottom__label"
          id="limit-contracts"
      >
        Limit Contracts
      </div>
      <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__value">
        <TextField
            defaultValue={symbolSizeOverridden ? FormulaUtils.OVERRIDDEN : value}
            disabled={symbolSizeOverridden}
            labelId="limit-contracts"
            max={symbolSizeOverridden ? undefined : 100}
            min={symbolSizeOverridden ? undefined : 1}
            name="symbolSize"
            noError
            onChange={onChangeLocal}
            placeholder="All"
            type={symbolSizeOverridden ? "text" : "number"}
            variant="border"
        />
      </div>
    </Fragment>
  )
}

LimitContracts.propTypes = {
  onChange: PropTypes.func.isRequired,
  symbolSizeOverridden: PropTypes.bool,
  value: PropTypes.string,
}

export default LimitContracts;
